import { render } from "./AnnouncementBanner.vue?vue&type=template&id=e8068fde&scoped=true"
import script from "./AnnouncementBanner.vue?vue&type=script&lang=js"
export * from "./AnnouncementBanner.vue?vue&type=script&lang=js"

import "./AnnouncementBanner.vue?vue&type=style&index=0&id=e8068fde&scoped=true&lang=css"

import exportComponent from "/home/biktorgj/Projects/Linube Cloud/Server_and_UI/ui-prod-4.22/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8068fde"]])

export default __exports__